<div class='full-form'>
  <!--<h3 *ngIf='datasetRS.record.value && !datasetACS.loading.value' class="addNew">
  Aggiungi servizio o crea nuovo
  <span class="material-icons" matTooltip="Crea servizio" (click)='createNewService()'>add</span>
</h3>
<br/>-->
<language-select
  [selected]='appService.language.value'
  (changed)='appService.language.next($event)'
  [languageCodes]='appService.supportedLanguageCodes'
  [activeLanguageCodes]='datasetMCS.activeLanguageCodes'
></language-select>

@if (datasetACS.loading.value) {
  <mat-progress-bar class='mt-24 mb-24' style='min-width:300px' mode="indeterminate"></mat-progress-bar>
}

@if (datasetACS.ready.value) {
  <div class='mt-24'>
    @if (!datasetRS.record.value && !datasetACS.loading.value) {
      <p>Questa traduzione non è ancora presente!</p>
      <div class="mt-24 mb-24 fx-row fx-justify-end fx-items-center" style="gap: 10px">
        <button mat-flat-button (click)='goPrevStep()'>Indietro</button>
      </div>
    }
    @if (datasetRS.record.value && datasetRS.record.value["lang"] === appService.language.value) {
      <custom-mat-table
        [relation]='"facilities"'
        [displayedColumns]='displayedColumns'
        [filterFormGroup]='filterFormGroup'
        [field]='field'
        [datasetACS]='parentDatasetACS'
        [datasetRS]='datasetRS'
        [dynamCols]='dynamCols'
        [stepName]='"trip_package_facilities"'
        [datasetCode]='"trip_packages"'
        [datasetConfig]='datasetConfig'
        [formConfigMap]='formConfig'
        (nextStep)='goNextStep()'
        [initialValueKey]='"title"'
      ></custom-mat-table>
    }
  </div>
}
</div>